import { PlatformSiteAri } from '@atlassian/ari';

import { query } from '@confluence/query-preloader-tools';
import { getIsActivityV3RecentsEnabled } from '@confluence/activity-v3-enabled/entry-points/getIsActivityV3RecentsEnabled';

import { PAGE_SIZE, OBJECT_TYPES_V3 } from './recentQueryConfig';
import {
	RecentContentMenuQuery,
	RecentContentMenuQueryV3,
} from './queries/RecentContentMenuQuery.graphql';

export function preloadRecentContentMenu(cloudId) {
	const isActivityV3RecentsEnabled = getIsActivityV3RecentsEnabled();
	return query({
		query: isActivityV3RecentsEnabled ? RecentContentMenuQueryV3 : RecentContentMenuQuery,
		variables: {
			cloudId: isActivityV3RecentsEnabled
				? PlatformSiteAri.create({ siteId: cloudId }).toString()
				: cloudId,
			after: '',
			first: PAGE_SIZE,
			eventTypes: [],
			objectTypes: isActivityV3RecentsEnabled ? OBJECT_TYPES_V3 : [],
		},
		fetchPolicy: 'network-only',
	});
}
